import moment from 'moment';

export const formatCurrency = (currency) => {
  return currency ? (currency).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '0.00';
}

export const nricOrPassport = (nric) => {
  if (!nric) {
    return '';
  } else if (nric.match(/\D/g)) {
    return nric; // If passport, there will be alphabets in it.
  } else {
    return nric ? (nric).replace(/(.{6})(.{2})(.*)/, '$1-$2-$3') : '';
  }
}

export const standardDate = (dateString) => {
  return moment(new Date(dateString)).format('DD MMMM YYYY');
}